
import { Users, TrendingUp, Calendar } from "lucide-react";
import { getExchangeLogo } from "@/utils/exchangeUtils";
import { StrategyWithDetails } from "@/types/strategy-types";

interface StrategyDetailHeaderProps {
  strategy: StrategyWithDetails;
  followerCount: number;
  isPro: boolean;
  pnlRatio: number | null;
  timespan: number | null;
}

const StrategyDetailHeader = ({ 
  strategy, 
  followerCount, 
  isPro,
  pnlRatio,
  timespan
}: StrategyDetailHeaderProps) => {
  // Format the performance value, handling null/undefined values
  const formattedPerformance = pnlRatio !== null && pnlRatio !== undefined 
    ? `${pnlRatio.toFixed(2)}%` 
    : strategy.expected_monthly_profit || strategy.performance_percentage 
      ? `${strategy.expected_monthly_profit || strategy.performance_percentage}%`
      : "N/A";

  return (
    <>
      <div className="flex justify-between items-start mb-4">
        <h2 className="text-xl md:text-2xl font-bold break-words flex-1 mr-4">
          {strategy.name || strategy.strategy_name || ''}
        </h2>
        <div className={`${
          isPro 
            ? "bg-[#F6C528]/10 border border-[#F6C528]/30" 
            : "bg-white"
          } rounded-lg p-2 flex-shrink-0`}
        >
          <img 
            src={getExchangeLogo(strategy.exchange)}
            alt={`${strategy.exchange} logo`}
            className="w-6 h-auto object-contain"
          />
        </div>
      </div>
      
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-8 mb-6">
        <div className="flex items-center gap-2">
          <Users className="w-5 h-5" />
          <span className="text-sm md:text-base">{followerCount.toLocaleString()} followers</span>
        </div>
        <div>
          <span className={`text-sm md:text-base ${isPro ? 'text-[#F6C528]' : ''}`}>
            Minimal Investment: {strategy.min_investment.toLocaleString()} {strategy.currency || 'USDT'}
          </span>
        </div>
      </div>

      {/* Display PNL ratio with proper formatting */}
      <div className="flex items-center gap-2 mb-6">
        <TrendingUp className={`w-5 h-5 ${isPro ? 'text-[#F6C528]' : 'text-green-500'}`} />
        <span className="text-lg md:text-2xl font-bold">
          {formattedPerformance}
        </span>
        {timespan && (
          <span className="text-gray-300 text-xs md:text-sm ml-2">
            <Calendar className="w-3 h-3 inline mr-1" />
            {timespan} days
          </span>
        )}
      </div>
    </>
  );
};

export default StrategyDetailHeader;
